import { render, staticRenderFns } from "./activeStatus.vue?vue&type=template&id=88f06194&scoped=true&"
import script from "./activeStatus.vue?vue&type=script&lang=js&"
export * from "./activeStatus.vue?vue&type=script&lang=js&"
import style0 from "./activeStatus.vue?vue&type=style&index=0&id=88f06194&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f06194",
  null
  
)

export default component.exports